import { ACL_MODULE_MAPPING } from "../constants/RouteConstant";
import ACCOUNTS_SUB_NAV from "./subNavList";
import {
  IconPoint,
  IconCode,
  IconLink,
  IconPlumPro,
  IconCampaign,
  IconRecharge,
  IconReport,
  IconSetting,
  IconHome,
} from "../components/Icons";
import { app_path } from "config";
// import INTEGRATIONS_SUB_NAV from "./integrationSubNavList";
export default [
  // {
  //   name: "Home",
  //   link: `/${app_path}/dashboard`,
  //   icon: IconHome,
  //   moduleId: ACL_MODULE_MAPPING.HOME,
  // },
  {
    name: "Send Rewards",
    link: `/${app_path}/xoxo-points/`,
    icon: IconPoint,
    moduleId: [
      ACL_MODULE_MAPPING.XOXO_POINT,
      ACL_MODULE_MAPPING.XOXO_VOUCHER,
      ACL_MODULE_MAPPING.XOXO_LINK,
      ACL_MODULE_MAPPING.PLUM_PRO,
    ],
  },
  // {
  //   name: "Xoxo Code",
  //   link: "/admin/xoxo-code/",
  //   icon: IconCode,
  //   moduleId: ACL_MODULE_MAPPING.XOXO_VOUCHER,
  // },
  // {
  //   name: "Xoxo Link",
  //   link: "/admin/xoxo-link/",
  //   icon: IconLink,
  //   moduleId: ACL_MODULE_MAPPING.XOXO_LINK,
  // },
  // {
  //   name: "Plum Pro",
  //   link: `/${app_path}/generate-brand-voucher/`,
  //   icon: IconPlumPro,
  //   moduleId: ACL_MODULE_MAPPING.PLUM_PRO,
  // },
  {
    name: "Campaigns",
    link: `/${app_path}/campaign/`,
    icon: IconCampaign,
    moduleId: ACL_MODULE_MAPPING.CAMPAIGN,
  },
  // {
  //   name: "Templates",
  //   link: `/${app_path}/templates/`,
  //   icon: IconCampaign,
  //   moduleId: ACL_MODULE_MAPPING.COMMON,
  // },
  {
    name: "Add Funds",
    link: `/${app_path}/recharge/`,
    icon: IconRecharge,
    moduleId: ACL_MODULE_MAPPING.RECHARGE,
  },
  {
    name: "Reports",
    link: `/${app_path}/reports/`,
    icon: IconReport,
    moduleId: ACL_MODULE_MAPPING.COMMON,
  },
  // {
  //   name: "Productivity Rewards",
  //   link: "/admin/awards",
  //   icon: IconPoint,
  //   moduleId: "AWARD",
  // },
  {
    name: "Xoxo Tokens",
    link: `/${app_path}/wallet/`,
    icon: IconPoint,
    moduleId: ACL_MODULE_MAPPING.WALLET,
  },
  // {
  //   name: "Settings",
  //   link: `/${app_path}/accounts/platform-preferences`,
  //   icon: IconSetting,
  //   moduleId: ACL_MODULE_MAPPING.ACCOUNT,
  //   subModules: ACCOUNTS_SUB_NAV,
  // },
  {
    name: "Integrations",
    link: `/${app_path}/integration-dashboard/manage-integration`,
    icon: IconPoint,
    moduleId: 69,
  },
];
